export default __webpack_public_path__ + "static/banner-82fc9c87ca08499b367d22d59897744b.webp";